/**
 * @description
 *	Available error codes for the entire application. This codes are intended
 *	to be publicly exposed, in order to avoid the collision of the error
 *	types.
 */
enum ErrorCode {
	UnknownError = "BIOMETRY-0000-0000",
	ValidationError = "BIOMETRY-0000-0001",
	HTTPClientError = "BIOMETRY-0000-0002"

	// Add more error codes, but never delete one...
}

export default ErrorCode
